module.exports = {"data":{"mapsJson":{"name":"No Rush 15 Minutes","description":"Prevent all damage until after each player has taken 4 turns.","filename":"map_no_rush_15_minutes.jpg","slug":"no_rush_15_minutes"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"no_rush_15_minutes","imageRegex":"/no_rush_15_minutes.jpg/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/map-no-rush-15-minutes.json
// module id = 1246
// module chunks = 2934972010917